import React from 'react';
import MenuItemAnchor from './MenuItemAnchor';

function isVisible() {
    return !Gaia.user.hasSubscription && Gaia.user.isAuthenticated;
}

function Toolbar(props) {
    const {component:Component = 'a', ...restProps} = props;
    if (!isVisible()) return null;

    return (<Component {...restProps} href="/membership/">
        {gettext('Membership')}
    </Component>);
}

function HamburgerMenu(props) {
    if (!isVisible()) return null;
    console.log(props);

    return <Toolbar component={MenuItemAnchor} {...props} />;
}

export default { Toolbar, HamburgerMenu };
